<template>
    <div>
        <loading-animation
            class="loading"
            v-show="loading"
        ></loading-animation>

        <div v-show="!loading">

            <vue-headful :title="pageTitle" />

            <div v-if="error">
                {{ errorMsg }}
            </div>

            <div v-else>

                <template
                    name="EVENTO NON ATTIVO"
                    v-if="!isActive"
                >
                    <b-container>
                        <b-row>
                            <b-col>
                                <h3 class="text-center">
                                    {{$t("Questa galleria non è attiva al momento")}}
                                    <br>
                                    {{$t("Per maggiori informazioni contatta {author}", {author: author})}}
                                </h3>
                            </b-col>
                        </b-row>
                    </b-container>
                </template>

                <template
                    name="EVENTO ATTIVO"
                    v-else
                >

                    <template
                        name="EVENTO ATTIVO NON ANCORA INIZIATO"
                        v-if="!isStarted"
                    >
                        <!-- TODO: template evento non ancora iniziato -->
                        <b-container>
                            <b-row>
                                <b-col>
                                    <h3 class="text-center">
                                        {{$t("L'accesso a questa galleria sarà possibile dal ") }} {{ eventData.eventStart | formatDateSlash}}
                                    </h3>
                                </b-col>
                            </b-row>
                        </b-container>
                    </template>

                    <template
                        name="EVENTO ATTIVO SCADUTO"
                        v-else-if="isExpired"
                    >
                        <!-- TODO: template evento scaduto -->
                        <b-container>
                            <b-row>
                                <b-col>
                                    <h3 class="text-center">
                                        {{ $t("L'accesso a questa galleria si è concluso il ") }} {{ eventData.eventEnd | formatDateSlash }}
                                    </h3>
                                </b-col>
                            </b-row>
                        </b-container>
                    </template>

                    <template
                        name="EVENTO ATTIVO CON COPERTINA"
                        v-else-if="hasCover"
                    >

                        <div
                            id="intro"
                            class="bg-light"
                        >
                            <div class="body-wrapper">

                                <main class="p-0 mt-0">

                                    <div
                                        role="navigation"
                                        class="navbar navbar-expand-sm fixed-bottom navbar-dark pt-5 pb-3 px-5"
                                    >
                                        <div class="navbar-text flex-grow-1 py-0 pr-3 mt-3">
                                            <h2 class="titolo-album text-uppercase mb-0">
                                                {{ title }}
                                            </h2>
                                            <p class="autore-album mt-1 mb-0">{{ author }}</p>
                                        </div>
                                        <a
                                            href="javascript:void(0)"
                                            class="btn btn-dark btn-lg mt-3 btn-rikorda3-alt"
                                            @click="onOpenPopup"
                                        >
                                            {{ $t("Sfoglia") }}
                                        </a>
                                    </div>
                                    <div
                                        class="sfondo-img-copertina bg-light"
                                        :style="{'background-image': 'url(' + coverUrl + ')'}"
                                    ></div>

                                </main>

                                <div
                                    v-if="showPopup"
                                    class="popup"
                                >
                                    <header
                                        role="navigation"
                                        class="navbar navbar-expand navbar-dark py-1 px-3"
                                    >
                                        <div class="flex-grow-1"></div>
                                        <a
                                            class="nav-link p-0"
                                            v-if="hasCover"
                                        >
                                            <button
                                                type="button"
                                                class="close"
                                                aria-label="Close"
                                                @click="onClosePopup"
                                            >
                                                <font-awesome-icon :icon="['fas', 'times']" />
                                            </button>
                                        </a>
                                    </header>

                                    <div class="container-fluid d-flex flex-column justify-content-center align-items-center">
                                        <mail-validation-form
                                            ref="mailValidationFormPopup"
                                            :eventId="eventData.eventId"
                                        />
                                    </div>

                                    <footer class="py-1 px-3"></footer>
                                </div>
                            </div>
                        </div>
                    </template>

                    <template
                        name="EVENTO ATTIVO SENZA COPERTINA"
                        v-else
                    >
                        <div
                            id="intro-no-cover"
                            class="schermata-form"
                        >
                            <div class="body-wrapper">
                                <header
                                    role="navigation"
                                    class="navbar fixed-top navbar-expand-md navbar-light shadow px-3 px-md-5"
                                >
                                    <b-navbar-toggle
                                        target="nav-collapse"
                                        class="navbar-toggler border-0 p-0"
                                    />

                                    <span class="navbar-brand mr-0 mr-md-3 p-0 d-inline-flex align-items-center">
                                        <img
                                            v-if="logoUrl"
                                            :src="logoUrl"
                                            alt="RikordaEventi"
                                            class="mw-100 mh-100"
                                        >
                                    </span>

                                    <span class="navbar-toggler border-0 p-0"></span>

                                    <b-navbar
                                        toggleable="md"
                                        id="navbarSupportedContent"
                                        class="navbar-collapse p-0 d-md-flex bg-transparent"
                                    >
                                        <b-collapse
                                            id="nav-collapse"
                                            is-nav
                                            class="navbar-nav pt-3 pt-md-0 align-items-center text-uppercase"
                                        >
                                            <router-link
                                                :to="{ name: 'page-howitworks' }"
                                                class="nav-item nav-link mr-md-3"
                                            >
                                                <font-awesome-icon :icon="['fas', 'question-circle']" />
                                                &nbsp;{{ $t("Come funziona") }}
                                            </router-link>
                                            <router-link
                                                :to="{ name: 'page-contacts' }"
                                                v-if="!isGlobalSite"
                                                class="nav-item nav-link ml-md-3"
                                            >
                                                <font-awesome-icon :icon="['fas', 'comments']" />
                                                &nbsp;{{ $t("Contatti") }}
                                            </router-link>
                                        </b-collapse>
                                    </b-navbar>
                                </header>

                                <div class="clearfix"></div>
                                <div class="d-flex justify-content-center align-items-center flex-wrap mx-auto py-4 px-2 mt-5">
                                    <main class="w-100 p-0 ">
                                        <div class="form-container bg-white rounded p-3">
                                            <h1 class="mb-0 text-uppercase text-center">{{ $t("Accedi all'evento") }}</h1>
                                            <mail-validation-form :eventId="eventData.eventId" />
                                        </div>
                                    </main>
                                </div>
                                <div class="clearfix"></div>

                            </div>
                        </div>
                    </template>
                </template>
            </div>

            <gallery-footer v-show="false" /><!-- footer nascosto, non si vede in questa paggina -->

        </div>

    </div>
</template>

<script>
import moment from "moment";
import LoadingAnimation from "../../components/LoadingAnimation";
import MailValidationForm from "../../components/MailValidationForm";
import GalleryFooter from "../../components/gallery/Footer";

export default {
    name: "EventIntro",

    components: {
        LoadingAnimation,
        MailValidationForm,
        GalleryFooter
    },

    data() {
        return {
            pageTitle: null,
            loading: false,
            error: false,
            errorMsg: "",
            showPopup: false,
            email: "",
            title: null,
            author: null,
            coverUrl: null,
            isActive: false,
            hasCover: false,
            isStarted: false,
            isExpired: false
        };
    },

    mounted() {
        var eventUrl = window.location.origin + this.$route.path;

        this.loading = true;

        this.$store
            .dispatch("GET_EVENT_DATA", { eventUrl: eventUrl })
            .then((result) => {
                console.debug("GET_EVENT_DATA", result);
                this.eventData = result;
                this.title = this.eventData.title;
                this.author = this.eventData.author;
                this.isActive = this.eventData.eventStatus === "ATTIVO";

                try {
                    var startDate = moment(this.eventData.eventStart);
                    var endDate = moment(this.eventData.eventEnd);
                    var currentDate = moment(this.eventData.currentDate);

                    if (!currentDate.isValid()) {
                        currentDate = moment.now();
                    }

                    this.isStarted = startDate.isValid()
                        ? currentDate >= startDate
                        : true;
                    this.isExpired = endDate.isValid()
                        ? currentDate > endDate
                        : false;
                } catch (error) {
                    console.error(error);
                }

                this.hasCover = this.eventData.coverPhotoId.length > 0;
                if (this.hasCover) {
                    this.coverUrl = this.getUrl(this.eventData.coverPhotoId);
                }
                this.setPageTitle();
            })
            .catch((error) => {
                console.error("GET_EVENT_DATA ERROR", error);
                switch (error) {
                    case "event not found":
                        this.$router.push({ name: "home" });
                        break;
                    default:
                        break;
                }
                this.error = true;
                this.errorMsg = error;
            })
            .finally(() => {
                this.loading = false;
            });
    },

    methods: {
        getUrl(photoId) {
            return this.$imagesService.getUrl(photoId, "hres");
        },

        setPageTitle() {
            this.pageTitle = [
                this.title || "",
                this.$t("di"),
                this.author || "",
                "- Rikorda"
            ].join(" ");
        },

        onOpenPopup() {
            this.showPopup = true;
        },

        onClosePopup() {
            this.showPopup = false;
        },

        resolveUrl(data) {
            const resolver = this.$router.resolve(data);
            return resolver.resolved.matched.length ? resolver.href : "#";
        }
    },
    computed: {
        logoUrl() {
            var shopData = this.$store.getters.shopData;
            console.debug("SHOPDATA", shopData);
            return shopData && shopData.logoUrl ? shopData.logoUrl : "";
        },
        isGlobalSite() {
            var shopData = this.$store.getters.shopData;
            console.debug("SHOPDATA", shopData);
            return shopData && shopData.isGlobalSite;
        }
    }
};
</script>

<style scoped>
.loading {
    position: absolute;
    top: 50%;
    left: calc(50% - 41px);
}

.body-wrapper,
.schermata-form {
    min-height: 100vh;
}
</style>
